import { render } from "./Q5DetailleeOptionB.vue?vue&type=template&id=0539509e"
import script from "./Q5DetailleeOptionB.vue?vue&type=script&lang=js"
export * from "./Q5DetailleeOptionB.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__